import { JsonConverter, JsonCustomConvert } from 'json2typescript';

import { RiskLevel } from '../../../../../core';

@JsonConverter
export class RiskLevelAdapter implements JsonCustomConvert<RiskLevel> {
    serialize(level: RiskLevel): any {
        switch (level) {
            case RiskLevel.MODERATE:
                return 'Medio';
            case RiskLevel.VERY_HIGH:
                return 'Alto/Muy alto';
            default:
                return 'Bajo';
        }
    }

    deserialize(level: any): RiskLevel {
        switch (level) {
            case 'Medio':
                return RiskLevel.MODERATE;
            case 'Alto/Muy alto':
                return RiskLevel.VERY_HIGH;
            default:
                return RiskLevel.LOW;
        }
    }
}
